<template>
    <show-admins ref="registerAdmin" v-bind:is-me="true" v-bind:is-deps="false" v-bind:title="'Εμφάνιση Διαχειριστών ΜΕ'" />
</template>

<script>
    import ShowAdmins from "../components/ShowAdmins";
    import {HTTP} from "../main";

    export default {
        name: "ShowAdminsMe",
        components: {
            ShowAdmins
        },
        created() {
            this.$store.dispatch("loading")
            HTTP.get( "/admin/find-all-me")
                .then(response => {
                        let resp = response.data;
                        this.$refs.registerAdmin.me_items = resp.responseData.map((x) => {
                            return {value: x, text: x.monaLek}
                        })
                    }
                ).finally(() => this.$store.dispatch("stop_loading"))
        },
    }
</script>
